import api from '../REST/api';
import createExportDump from '../utils/create-export-dump';

const dump = createExportDump(api.exportAllInvoices, 'status', 'invoices');

export default dump;
